import { http_client } from '@/plugins/http_client';

const url = 'api/solicitudes';

const getProcesos = async (filtros = {})=> await http_client(`${url}/renuncia/proceso-empleado`,filtros);
const postCrearSolicitudRenuncia = async (data)=> await http_client(`${url}/renuncia/crear`,data,"post",{ headers: { 'Content-Type': 'multipart/form-data' } }); 

export default {
    getProcesos,
    postCrearSolicitudRenuncia
}